import { MenuId } from 'types';

export const MENUS = '/api/v1/menus';
export const MENU = (menuId: MenuId) => `/api/v1/menus/${menuId}`;
export const MENUS_REPORTS_CATERING = '/api/v1/reports/diet/catering';
export const MENUS_REPORTS_GIVEAWAY = '/api/v1/reports/diet/giveaway';
export const MENUS_GROUPS = '/api/v1/menus/groups';
